import React from 'react';
import { makeStyles, mergeClasses, Text, tokens } from '@fluentui/react-components';
import { PageReference } from '@gkn-ili/views/src/OrderDocumentation';
import { getPageContent, useAppActions, useAppState } from '../../context';
import { AppEditDialogActions } from './components/dialogActions';
import { useForm } from 'react-hook-form';
import { getPageType, pageTypeNationales } from '../../utils/orderDocumentationHelpers';
import { isPageReferenceActivity, isPageReferenceActivityGroup } from '@gkn-ili/views/dist/OrderDocumentation';
import {
  AppDialogBody,
  AppDialogContent,
  AppDialogHeader,
  AppDialogSurface,
  DialogOptions,
} from './components/baseComponents';

const useStyles = makeStyles({
  blockText: {
    display: 'block',
    marginBlock: tokens.spacingVerticalS,
  },
  referenceText: {
    fontStyle: 'italic',
    fontWeight: tokens.fontWeightMedium,
    paddingLeft: tokens.spacingHorizontalM,
  },
});

export default function AppDeleteModal(props: { reference: PageReference; dialogOptions: DialogOptions }): JSX.Element {
  const appState = useAppState();
  const appActions = useAppActions();
  const styles = useStyles();

  // Retrieve the correct data
  const ref = props.reference;
  // The step is potentially undefined when it is already deleted, because the asynchronous server push might come back
  // to the client before the request is completely handled.
  const page = getPageContent(appState.orderView, ref);

  const pageTypeNationale = pageTypeNationales[getPageType(ref)];
  const name = page?.name ?? 'deleted';

  const formHandlers = useForm<never>({});
  const onSubmit = formHandlers.handleSubmit(async () => {
    if (isPageReferenceActivity(ref)) {
      await appActions.editOrder.deleteActivity(ref);
    } else if (isPageReferenceActivityGroup(ref)) {
      await appActions.editOrder.deleteActivityGroup(ref);
    } else {
      await appActions.editOrder.deleteStep(ref);
    }
    props.dialogOptions.onCloseDialog();
  });

  return (
    <AppDialogSurface dialogOptions={props.dialogOptions}>
      <form>
        <AppDialogBody dialogOptions={props.dialogOptions}>
          <AppDialogHeader dialogOptions={props.dialogOptions}>Delete step</AppDialogHeader>
          <AppDialogContent dialogOptions={props.dialogOptions}>
            <Text block className={styles.blockText}>
              Are you sure you want to delete {pageTypeNationale}
            </Text>
            <Text block italic className={mergeClasses(styles.blockText, styles.referenceText)}>
              {name}
            </Text>
            <Text block className={styles.blockText}>
              {' '}
              including all of its sub components.{' '}
            </Text>
          </AppDialogContent>
          <AppEditDialogActions
            onCancel={props.dialogOptions.onCloseDialog}
            submitDisabled={formHandlers.formState.isSubmitting}
            onSubmit={onSubmit}
            showDelete
          />
        </AppDialogBody>
      </form>
    </AppDialogSurface>
  );
}
